"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* istanbul ignore file */
var UTF8Encoder = /*#__PURE__*/function () {
  function UTF8Encoder() {
    (0, _classCallCheck2.default)(this, UTF8Encoder);
    this.encoder = new TextEncoder();
  }

  (0, _createClass2.default)(UTF8Encoder, [{
    key: "encode",
    value: function encode(value) {
      return this.encoder.encode(value);
    }
  }]);
  return UTF8Encoder;
}();

exports.default = UTF8Encoder;